import { Tooltip as AntdTooltip } from "@empglabs/backoffice-ui-kit"

const Tooltip = props => {
  return <AntdTooltip {...props} />
}

export default Tooltip
